import React from 'react';

import {ListItemButton, ListItemIcon, ListItemText, useMediaQuery, useTheme} from '@mui/material';
import {
  AirplanemodeInactive as AirplanemodeInactiveIcon,
  Home as HomeIcon,
  Info as InfoIcon,
  Radar as RadarIcon,
  Security as SecurityIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';
import {Outlet, useNavigate} from 'react-router-dom';
import {defineMessages, useIntl} from 'react-intl';

import {Types, useAuth} from '@wheeebo/polaris-api';
import {PageFrame, usePageMenuDrawer} from '@wheeebo/polaris-ui';

import {config} from '@components/Constants';

const msgs = defineMessages({
  buttonAbout: {
    id: 'pages.member.MemberPageFrame.button.about',
    defaultMessage: 'About',
  },
  buttonHome: {
    id: 'pages.member.MemberPageFrame.button.home',
    defaultMessage: 'Home',
  },
  buttonMissions: {
    id: 'pages.member.MemberPageFrame.button.missions',
    defaultMessage: 'Missions',
  },
  buttonPrivacyPolicy: {
    id: 'pages.member.MemberPageFrame.button.privacyPolicy',
    defaultMessage: 'Privacy Policy',
  },
  buttonSettings: {
    id: 'pages.member.MemberPageFrame.button.settings',
    defaultMessage: 'Settings',
  },
});

function MemberPageFrame(): JSX.Element {
  const intl = useIntl();
  const {account} = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const {open, close} = usePageMenuDrawer();
  const isBigScreen = useMediaQuery(theme.breakpoints.up('sm'));
  const redirect = (path: string) => {
    navigate(path);
    if (!isBigScreen) {
      close?.();
    }
  };
  if (!open || !close) {
    return <></>;
  }
  return (
    <PageFrame
      chipColor="info"
      chipLabel="ATC"
      adminWebsiteURL={account?.role === Types.MemberRoleSystemAdmin ? config.ADMIN_WEBSITE_URL : undefined}
      memberWebsiteURL={config.MEMBER_WEBSITE_URL}
      menu={
        <>
          <ListItemButton onClick={() => redirect('/')}>
            <ListItemIcon>{<HomeIcon />}</ListItemIcon>
            <ListItemText primary={intl.formatMessage(msgs.buttonHome)} />
          </ListItemButton>
          <ListItemButton onClick={() => redirect('/monitor')}>
            <ListItemIcon>{<RadarIcon />}</ListItemIcon>
            <ListItemText primary="Monitor" />
          </ListItemButton>
          <ListItemButton onClick={() => redirect('/noFlyZones')}>
            <ListItemIcon>{<AirplanemodeInactiveIcon />}</ListItemIcon>
            <ListItemText primary="No Fly Zones" />
          </ListItemButton>
          <ListItemButton onClick={() => redirect('/settings')}>
            <ListItemIcon>{<SettingsIcon />}</ListItemIcon>
            <ListItemText primary={intl.formatMessage(msgs.buttonSettings)} />
          </ListItemButton>
          <ListItemButton onClick={() => redirect('/privacyPolicy')}>
            <ListItemIcon>{<SecurityIcon />}</ListItemIcon>
            <ListItemText primary={intl.formatMessage(msgs.buttonPrivacyPolicy)} />
          </ListItemButton>
          <ListItemButton onClick={() => redirect('/about')}>
            <ListItemIcon>{<InfoIcon />}</ListItemIcon>
            <ListItemText primary={intl.formatMessage(msgs.buttonAbout)} />
          </ListItemButton>
        </>
      }>
      <Outlet />
    </PageFrame>
  );
}

export default React.memo(MemberPageFrame);
